import { Alert, TextField } from "@mui/material"
import PrimaryButton from "../../components/global/PrimaryButton"
import { useContext, useState } from "react"
import { AppContext } from "../../common/contexts/app_context/app_context"
import ThemeSwitch from "../../components/global/ThemeSwitch"
import { useNavigate } from "react-router"
import { UserAuthContext } from "../../common/contexts/user_auth_context/user_auth_context"
import { useUserAuthStore } from "../../stores/global/userAuth"
import { LoginForm } from "../../types/global/UserAuthTypes"
import PasswordInput from "../../components/auth/PasswordInput"

function Login() {
  const logo = require("../../assets/gdol.png")
  const iso = require("../../assets/iso-branco.png")
  const { theme } = useContext(AppContext)
  const { login } = useContext(UserAuthContext)
  const { erro, messageErro, setErro } = useUserAuthStore()
  let navigate = useNavigate()

  const [form, setForm] = useState<LoginForm>({ login: "", password: "" })
  const [erroLogin, setErroLogin] = useState(false)
  const [erroPassword, setErroPassword] = useState(false)

  const validateFields = (): boolean => {
    if (form.login == null || form.login == "") {
      setErroLogin(true)
      return false
    }
    if (form.password == null || form.password == "") {
      setErroPassword(true)
      return false
    }
    return true
  }

  return (
    <div className="w-screen lg:h-screen flex items-center justify-between flex-col lg:px-1 lg:flex-row-reverse overflow-scroll-y bg-light-mode-2 dark:bg-dark-mode-2">
      <div className="min-h-screen w-full lg:h-[99%] lg:w-2/5 px-[5%] p-12 lg:pb-4 items-center justify-center overflow-clip lg:overflow-y-scroll">
        <div className="w-full h-full flex flex-col items-center justify-between">
          <div className="flex justify-between w-full lg:flex-row-reverse">
            <ThemeSwitch label={false} />
            <div className="w-1/3 lg:hidden">
              <PrimaryButton onClick={() => {
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth"
                })
              }}>Criar conta</PrimaryButton>
            </div>
          </div>
          <div className="2xl:w-[400px] mt-8 lg:mt-0">
            <div className="w-full">
              <img src={logo} alt="logo gdol" className="w-[100px]" />
            </div>
            <div className="text-black dark:text-white font-semibold w-full mt-14 lg:mt-8">
              <h1 className="">
                Bem-vindo ao
                <span className="text-primary-green">
                  {" Sistema SGQ"}
                </span>
              </h1>
              <h1 className="text-4xl">
                Login
              </h1>
            </div>
            <div className="w-full mt-6 mb-4">
              <h1 className="font-semibold text-black dark:text-white">
                Informe os dados abaixo
              </h1>
            </div>
            <form className="w-full flex gap-4 flex-col items-center justify-center" onSubmit={() => {
              if (validateFields()) {
                login(form)
              }
            }}>
              <TextField
                fullWidth
                type="email"
                helperText={erro == true ? "" : (erroLogin == true ? "Digite um login válido" : "")}
                label="Login"
                value={form.login}
                error={erro || erroLogin}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setErro(false)
                  setErroLogin(false)
                  setForm((form) => ({
                    ...form,
                    login: event.target.value
                  }))
                }}
                id="outlined-size-small"
                size="small"
              />
              <PasswordInput
                error={erro || erroPassword}
                label="Senha"
                value={form.password}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setErro(false)
                  setErroPassword(false)
                  setForm((form) => ({
                    ...form,
                    password: event.target.value
                  }))
                }}
                helperText={erro == true ? "" : (erroPassword == true ? "Digite uma senha válida" : "")}
              />
              <div className="w-full flex justify-end">
                <p className="text-sm text-primary-green font-medium cursor-pointer">Esqueceu sua senha?</p>
              </div>
              <div className="w-full flex items-center justify-center">
                <div className="w-1/2">
                  <PrimaryButton
                    type="submit"
                    onClick={() => {
                      if (validateFields()) {
                        login(form)
                      }
                    }}>Entrar</PrimaryButton>
                </div>
              </div>
              {
                erro == true &&
                <Alert severity="error">{messageErro}</Alert>
              }
            </form>
            <div className="my-8 w-full flex items-center justify-end flex-col text-sm text-center text-black dark:text-white">
              <p className="font-semibold">
                Possui um login no antigo sistema da GDOL?
              </p>
              <p>
                Configure agora seu primeiro acesso no novo sistema
              </p>
              <div className="w-1/2 mt-4">
                <PrimaryButton
                  onClick={() => navigate("/old_configure")}
                  buttonColor={theme == "light" ? "secondary" : "secondary-white"}>Configurar</PrimaryButton>
              </div>
            </div>
          </div>
          <h1 className="text-[12px] text-center text-black dark:text-white">@SGQ Sistema de Gestão de Qualidade | Todos os Direitos Reservados</h1>
        </div>
      </div>
      <div className="h-screen w-full  mb-1 lg:mb-0 lg:h-[99%] lg:w-3/5 bg-primary-green rounded-sm flex flex-col items-start justify-between px-12 py-4 text-white">
        <div></div>
        <div className="w-full items-center lg:items-start lg:w-1/2 flex gap-8 flex-col text-center lg:text-start">
          <h1 className="font-semibold text-5xl">Primeira vez por aqui?</h1>
          <p className="text-sm lg:text-[16px] font-medium ">Simplifique a gestão do PBQP-H e da ISO 9001
            da sua empresa com o sistema mais completo
            do mercado.</p>
          <div className="w-1/2">
            <PrimaryButton buttonColor="white">Ver Planos</PrimaryButton>
          </div>
        </div>
        <div className="w-full flex items-end justify-center">
          <img src={iso} alt="logo iso" className="w-32" />
        </div>
      </div>
    </div>

  )
}

export default Login